import {
  ArrowDropDown,
  ArrowDropUp,
  DragIndicator,
  RemoveRedEye,
  VisibilityOff,
} from '@mui/icons-material'
import { ReactElement } from 'react'
import { I18n } from 'common'
import styled from 'styled-components'
import { SearchOptions, SearchPreference } from '../interfaces'
import { defaultTheme } from '../../../theme/index'

interface SearchPreferencesProps {
  index: number
  item: SearchPreference
  onHideElement: (item: SearchPreference) => void
}

export const SearchPreferenceItem = (
  props: SearchPreferencesProps
): ReactElement => {
  const { item, index, onHideElement } = props
  return (
    <Wrapper>
      <Index>{index}</Index>
      <ItemBox {...props}>
        <DragIcon {...props}>
          <ArrowUpIcon />
          <DragIndicator />
          <ArrowDownIcon />
        </DragIcon>
        <Title {...{ ...props }}>
          {<I18n name={item.id} />}{' '}
          {!item.hidden && index === 1 && <I18n name={'default'} />}
        </Title>
        {!item.hidden && item.id !== SearchOptions.vehicle_ymme && (
          <RemoveRedEyeIcon onClick={() => onHideElement(item)} />
        )}
        {item.hidden && item.id !== SearchOptions.vehicle_ymme && (
          <VisibilityOffIcon onClick={() => onHideElement(item)} />
        )}
      </ItemBox>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  padding-bottom: 1.5rem;
`

const Index = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 1rem;
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  /* identical to box height, or 142% */
  color: #797979;
  mix-blend-mode: normal;
  opacity: 0.9;
`

const DragIcon = styled.div<SearchPreferencesProps>`
  display: flex;
  flex-direction: column;
  color: ${(p) =>
    p.item?.hidden
      ? defaultTheme.colors.disabledButtonText
      : defaultTheme.colors.columnBorder};
`

const ArrowUpIcon = styled(ArrowDropUp)`
  position: relative;
  top: 0.5rem;
  color: ${defaultTheme.colors.greyLight};
`

const ArrowDownIcon = styled(ArrowDropDown)`
  position: relative;
  bottom: 0.5rem;
  color: ${defaultTheme.colors.greyLight};
`

const RemoveRedEyeIcon = styled(RemoveRedEye)`
  color: ${defaultTheme.colors.columnBorder};
`

const VisibilityOffIcon = styled(VisibilityOff)`
  color: ${defaultTheme.colors.disabledButtonText};
`

const Title = styled.div<SearchPreferencesProps>`
  flex-grow: 1;
  text-align: start;
  padding-left: 0.2rem;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  color: ${(p) => (p.item.hidden ? '#adadaa' : '#050505')};
  mix-blend-mode: normal;
  opacity: 0.9;
`

const ItemBox = styled.div<SearchPreferencesProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
  padding: 10px 16px 10px 12px;
  gap: 10px;
  width: 520px;
  height: 64px;
  background: ${(p) =>
    p?.item?.hidden
      ? defaultTheme.colors.disabledBackground
      : defaultTheme.colors.rowFeaturedBackground};
  border: 1px solid #e5e4e1;
  border-radius: 4px;
`
